export default class HoseTestModel {
  constructor(data = {}) {
   
    let template = {
      id: 0,
      hoseId: null,
      testDate: null,
      testPressureKpa: null,
      result: null,
      notes: null,
      nextTestDueDate: null,
      createdAt: null,
      createdBy: null
    }

    this.data = data ? data : template;
  }
 
  getId = () => { return this.data.id; }
  setId = (value) => { this.data.id = value;  }

  getHoseId = () => { return this.data.hoseId; }
  setHoseId = (value) => { this.data.hoseId = value;  }

  getTestDate= () => { return this.data.testDate; }
  setTestDate = (value) => { this.data.testDate = value;  }

  getTestPressureKpa= () => { return this.data.testPressureKpa; }
  setTestPressureKpa = (value) => { this.data.testPressureKpa = value;  }

  getResult= () => { return this.data.result; }
  setResult = (value) => { this.data.result = value;  }

  getNotes= () => { return this.data.notes; }
  setNotes = (value) => { this.data.notes = value;  }

  getNextTestDueDate= () => { return this.data.nextTestDueDate; }
  setNextTestDueDate = (value) => { this.data.nextTestDueDate = value;  }

  getCreatedAt = () => { return this.data.createdAt; }
  setCreatedAt = (value) => { this.data.createdAt = value; }

  getCreatedBy =  () => { return this.data.createdBy; }
  setCreatedBy = (value) => { this.data.createdBy = value; }


  toJson = () =>{
    return JSON.stringify(this.data);
  }

  /** 
   * This is used for application code to confirm 
   * the object is indeed a HoseTestModel
   */
  getType = () => {
    return "HoseTestModel";
  }
}